import { createSelector } from 'reselect';
export const selectAuthState = state => state.auth;
export const selectAuthenticatedUser = state => state.auth.user;
export const selectAuthUserScopesSet = createSelector([selectAuthenticatedUser], user => new Set(user && user.scopes || []));
export const selectAuthenticatedPortal = state => state.auth.portal;
export const selectAuthGates = state => state.auth.gates;
export const selectAuthGatesSet = createSelector([selectAuthGates], gates => new Set(gates));